module.exports = __webpack_public_path__ + "static/media/28_tn.159ccf09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/28_tn.jpg
// module id = 166
// module chunks = 0